module.exports = __webpack_public_path__ + "img/52.cbea1424.png";